import { mask as toMask, unMask } from 'remask'

import { normalizeCpfCnpj } from '~/utils/cnpj'

const maskType = {
  document: ['999.999.999-99', 'SS.SSS.SSS/SSSS-99'],
  cpf: ['999.999.999-99'],
  cnpj: ['SS.SSS.SSS/SSSS-99'],
  phone: ['(99) 9999-9999', '(99) 9 9999-9999'],
  zipCode: ['99999-999'],
}

export const maskInterceptor = (mask: keyof typeof maskType) => {
  return (value: string) => {
    if (!value) return value

    const originalValue = unMask(value)
    const maskedValue = toMask(originalValue, maskType[mask])
    return maskedValue
  }
}

// Seleção por conteúdo (não por tamanho), senão a máscara de CPF silencia as letras ao digitar CNPJ alfanumérico.
export const maskCpfCnpj = (value: string) => {
  if (!value) return value

  const raw = normalizeCpfCnpj(value)
  const ehCnpj = /[A-Z]/.test(raw) || raw.length > 11

  return maskInterceptor(ehCnpj ? 'cnpj' : 'cpf')(value)
}

export const maskRemove = (value: string) => {
  if (!value) return value

  const originalValue = unMask(value)
  return originalValue
}

export function maskNumberQtyTotal(value: string): string {
  value = value.replace(/\./g, '')

  const parts = value.split(',')
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.')
  value = parts.join(',')

  return value
}
